import React from 'react'
import header from '../assets/images/afficheFantasticArt.PNG'
import '../assets/styles/Header.css'
import { Link } from 'react-router-dom'

function Header() {
  return (
    <div className='headerContainer'>
        <img src={header} alt="FIFF gerardmer"/>
        <div className="headerNavbar">
            <li>
              <Link to='/accueil'><ul><span id="dropDown">Compétition</span><span id="click" className="material-symbols-outlined">
              movie
              <span id="clickWord"> Long</span></span></ul></Link>

              <Link to='/court'><ul><span id="dropDown">Court-métrages</span><span id="click" className="material-symbols-outlined">
              movie
              <span id="clickWord"> Court</span></span></ul></Link>

              <Link to='/programme'><ul><span id="dropDown">Programme</span><span id="click" className="material-symbols-outlined">
                  table<span id="clickWord"> Prog'</span></span></ul></Link>

              <Link to='/pass'><ul><span id="dropDown">Pass</span><span id='click' className="material-symbols-outlined">
                admin_panel_settings
                <span id="clickWord"> Pass</span></span></ul></Link>
                

              <Link to='/palmares'><ul><span id="dropDown">Palmarès</span><span id="click" className="material-symbols-outlined">
                military_tech<span id="clickWord"> Prix</span>
              </span></ul></Link>

            </li>
        </div>
    </div>
  )
}

export default Header